export passengerTypesReducer = (state = [], action) ->
  switch action.type
    when 'LOAD_LOC_TYPE_SUCCESS'
      if action.passengerTypes
        action.passengerTypes
      else
        state
    else
      state